module.exports = __webpack_public_path__ + "img/banner.79c5a65b.png";